import * as api from "../../services/user-service";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const allUsers = createAsyncThunk("FETCH_USERS", async (payload) => {
  const response = await api.getAllUsers();
  return response;
});
